var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_72332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5C4.5 8.03043 4.71071 8.53914 5.08579 8.91421C5.46086 9.28929 5.96957 9.5 6.5 9.5C7.03043 9.5 7.53914 9.28929 7.91421 8.91421C8.28929 8.53914 8.5 8.03043 8.5 7.5C8.5 6.96957 8.28929 6.46086 7.91421 6.08579C7.53914 5.71071 7.03043 5.5 6.5 5.5C5.96957 5.5 5.46086 5.71071 5.08579 6.08579C4.71071 6.46086 4.5 6.96957 4.5 7.5V7.5Z",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 10.7834L11.921 10.1764C11.8761 10.1045 11.8136 10.0452 11.7394 10.0041C11.6652 9.96298 11.5818 9.94141 11.497 9.94141C11.4122 9.94141 11.3288 9.96298 11.2546 10.0041C11.1804 10.0452 11.1179 10.1045 11.073 10.1764L8.438 14.3984L7.362 12.6764C7.31705 12.6045 7.25456 12.5452 7.18039 12.5041C7.10621 12.463 7.0228 12.4414 6.938 12.4414C6.8532 12.4414 6.76979 12.463 6.69561 12.5041C6.62144 12.5452 6.55895 12.6045 6.514 12.6764L3.5 17.4984H8.5",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23.5H1.5C1.23478 23.5 0.98043 23.3946 0.792893 23.2071C0.605357 23.0196 0.5 22.7652 0.5 22.5V1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H14.793C15.0582 0.500057 15.3125 0.605451 15.5 0.793L19.207 4.5C19.3946 4.68749 19.4999 4.9418 19.5 5.207V8.5",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.5C11.5 19.0913 12.1321 20.6174 13.2574 21.7426C14.3826 22.8679 15.9087 23.5 17.5 23.5C19.0913 23.5 20.6174 22.8679 21.7426 21.7426C22.8679 20.6174 23.5 19.0913 23.5 17.5C23.5 15.9087 22.8679 14.3826 21.7426 13.2574C20.6174 12.1321 19.0913 11.5 17.5 11.5C15.9087 11.5 14.3826 12.1321 13.2574 13.2574C12.1321 14.3826 11.5 15.9087 11.5 17.5Z",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.5V14.5",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5L15.25 16.75",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5L19.75 16.75",
    stroke: "#6B6C7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_72332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/imageUpload.a0d5ea5603f1044b80503e50ce7bdc3c.svg";
export { ForwardRef as ReactComponent };